import React from 'react';
import { ArrowRight, MapPin } from 'lucide-react';

const BADGE_COLORS = {
  'Largest Project': 'bg-[#C41E3A] text-white',
  'Warehouse Complex': 'bg-[#1A1A1A] text-[#D1D5DB] border border-[#4A4A4A]',
  'Food Grade': 'bg-[#1A1A1A] text-[#D1D5DB] border border-[#4A4A4A]',
};

const FeaturedCard = ({ project, onClick, className = '' }) => (
  <div
    className={`relative overflow-hidden cursor-pointer group ${className}`}
    onClick={() => onClick(project)}
    data-testid={`featured-card-${project.id}`}
  >
    <img
      src={project.thumbImg}
      alt={project.name}
      loading="lazy"
      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105 grayscale-[20%] group-hover:grayscale-0"
    />
    <div className="absolute inset-0 bg-gradient-to-t from-black/95 via-black/30 to-transparent" />
    <div className="absolute inset-0 border-2 border-transparent group-hover:border-[#C41E3A] transition-colors duration-300" />

    {/* Badge */}
    <div className={`absolute top-4 left-4 text-[10px] font-heading tracking-widest px-2.5 py-1 ${BADGE_COLORS[project.badge] || 'bg-[#C41E3A] text-white'}`}>
      {project.badge}
    </div>

    {/* Content */}
    <div className="absolute bottom-0 left-0 right-0 p-5 lg:p-6">
      <div className="flex items-center gap-1.5 mb-1.5">
        <MapPin size={10} strokeWidth={1.5} className="text-[#C41E3A] shrink-0" />
        <span className="text-[#9CA3AF] text-xs font-body">{project.location}</span>
        <span className="text-[#4A4A4A] mx-1">·</span>
        <span className="text-[#C41E3A] text-xs font-body">{project.area}</span>
      </div>
      <h3 className="font-heading text-xl lg:text-2xl text-white leading-tight">{project.name}</h3>
      <p className="text-[#9CA3AF] text-xs font-body mt-1 line-clamp-2 leading-relaxed">{project.description}</p>
      <div className="flex items-center gap-2 mt-3 text-[#C41E3A] text-xs font-body uppercase tracking-widest group-hover:gap-3 transition-all">
        View Project <ArrowRight size={12} strokeWidth={2} />
      </div>
    </div>
  </div>
);

export const FeaturedProjects = ({ projects, onOpenModal }) => {
  const [hero, second, third] = projects;
  return (
    <div className="mb-1" data-testid="featured-projects">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-px bg-[#4A4A4A] lg:max-h-[560px]">
        <FeaturedCard
          project={hero}
          onClick={onOpenModal}
          className="lg:col-span-7 aspect-[4/3] lg:aspect-auto lg:min-h-[480px] lg:max-h-[560px]"
        />
        <div className="lg:col-span-5 grid grid-rows-2 gap-px bg-[#4A4A4A]">
          <FeaturedCard project={second} onClick={onOpenModal} className="aspect-video lg:aspect-auto lg:max-h-[280px]" />
          <FeaturedCard project={third} onClick={onOpenModal} className="aspect-video lg:aspect-auto lg:max-h-[280px]" />
        </div>
      </div>
    </div>
  );
};
